import z from 'zod';

export const ServiceAreaSchema = z
  .object({
    id: z.number(),
    name: z.string(),
    key: z.string(),
  })
  .strict();

export type ServiceAreaDto = z.infer<typeof ServiceAreaSchema>;
